import { createFileRoute } from "@tanstack/react-router";
import { SeoPageShell, H2 } from "@/components/SeoPageShell";

const TITLE = "About Like2Fit — The AI Outfit Finder for Shoppers";
const DESC = "Like2Fit is an AI-powered fashion discovery app from Ratecard Technologies Limited. Find every clothing item in a photo and shop the look at your budget.";
const URL = "https://like2fit.com/about";

export const Route = createFileRoute("/about")({
  component: AboutPage,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: TITLE,
          url: URL,
          about: {
            "@type": "Organization",
            name: "Like2Fit",
            url: "https://like2fit.com/",
            parentOrganization: { "@type": "Organization", name: "Ratecard Technologies Limited" },
          },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://like2fit.com/" },
            { "@type": "ListItem", position: 2, name: "About", item: URL },
          ],
        }),
      },
    ],
  }),
});

function AboutPage() {
  return (
    <SeoPageShell
      eyebrow="About"
      h1="Built for shoppers who screenshot everything"
      intro="Like2Fit is an AI outfit finder that turns the screenshots in your camera roll into shoppable wardrobes — at the budget you set."
    >
      <H2>Why we built it</H2>
      <p>Every shopper has the same camera roll: outfits saved from Instagram, TikTok, Pinterest and street-style blogs — with no idea where to buy any of it. We built Like2Fit so you never have to reverse-search again.</p>

      <H2>How it's different</H2>
      <p>Most shop-the-look tools need a brand tag or product link. Like2Fit reads the image directly with computer-vision AI, so any photo works. Results come in budget, mid and premium tiers, so you decide how to spend.</p>

      <H2>The company</H2>
      <p>Like2Fit is built by Ratecard Technologies Limited. Questions or partnership ideas? Reach us at <a href="mailto:support@like2fit.com" style={{ color: "#FF5C5C" }}>support@like2fit.com</a>.</p>

      <H2>What's next</H2>
      <p>We're expanding retailer coverage, sharpening pairing for Style My Wardrobe, and rolling out daily outfit suggestions based on the weather and what's in your closet. Try it today.</p>
    </SeoPageShell>
  );
}
